// import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import React from "react";
import "nepali-datepicker-reactjs/dist/index.css";
import "@zener/nepali-datepicker-react/index.css";
import "./styles.css";
import InputWrapper from "./inputWrapper";
import { Box } from "@mui/system";
import calendar from "../../images/calendar-icon.svg";
import { propsButton } from "./inputField";
import NepaliDatePicker from "@zener/nepali-datepicker-react";

interface IProps {
  date: string | null | undefined;
  setDate: ({ bsDate, adDate }: { bsDate: string; adDate: string }) => void;
  label: string;
  headerComponent?: React.ReactNode | null;
}

export const NepaliDateField = ({
  date,
  setDate,
  label,
  headerComponent,
}: IProps) => {
  const handleDateChange = (dateValue: any) => {
    const formattedDate = dateValue.format("YYYY-MM-DD");

    const adDate = dateValue.toAD().toString();

    setDate({ bsDate: formattedDate, adDate });
  };

  return (
    <InputWrapper label={label} headerComponent={headerComponent}>
      <div
        style={{
          width: "100%",
        }}
      >
        <NepaliDatePicker
          value={date || ""}
          onChange={handleDateChange}
          lang="en"
          className={"input-button"}
          portalClassName="calendar-portal"
          calendarClassName="my-custom-datepicker"
        />

        <Box right={12} bottom={14} position={"absolute"}>
          <img src={calendar} alt="calendar" style={propsButton} />
        </Box>
      </div>
    </InputWrapper>
  );
};
